// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"x6Fu16DA","title":"FEPsYGd_","errorIcon":"pdwStGc9","emptyIcon":"BRaEfosA","subtitle":"Lhvv7VMn","link":"nhTyMtv6"};